<script>
export default {
    props: {
        store: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            data: {},
        };
    },
    watch: {
        store() {
            var vm = this;

            vm.load();
        }
    },
    mounted() {
        var vm = this;

        vm.load();
    },
    methods: {
        load() {
            var vm = this;

            vm.create();
        },
        create() {
            var vm = this;

            vm.data = Object.assign({}, vm.store);
        },
        // =====
        async submit() {
            var vm = this;
            this.$loading.on('store_detail_config_submit');

            try {
                var postData = vm._createPostData(vm.data);
                var resp = await this.$api.Store.create(postData);

                var data = resp.data;

                vm.$emit('onUpdate');

                this.$flash.success(data.message);
            } catch (err) {
                this.$flash.error(err.response.data.message);
            }
            this.$loading.off('store_detail_config_submit');
        },
        _createPostData(data) {
            return data;
        },
        async destroy() {
            var vm = this;

            vm.$alert.confirm(vm.$t('basic.alert.delete'), async function (result) {
                if (result.isConfirmed) {
                    var id = vm.$route.params.id;

                    var params = {
                        id: id,
                        is_permanent: 0
                    };

                    try {
                        vm.$loading.on('store_detail_config_delete');

                        var resp = await vm.$api.Store.delete(params);

                        vm.$emit('onDelete');

                        vm.$flash.success(resp.data.message);
                    } catch (error) {
                        vm.$flash.error(error.response.data.message);
                    }

                    vm.$loading.off('store_detail_config_delete');
                }
            });
        },
        fetchUsers: async function (params) {
            const resp = await this.$api.User.all(params)

            const data = resp.data.data

            const list = data.map(row => ({
                id: row.id,
                text: row.text,
                model: row,
            }))

            const meta = resp.data.meta

            return {
                options: list,
                more: meta.current_page < meta.last_page
            }
        }
    }
};
</script>

<template>
    <BRow class="justify-content-center">
        <BCol lg="8">
            <b-form @submit="submit()">
                <BCard no-body>
                    <BCardBody>
                        <loading :loading="$loading.get('store_detail_create')" variant="dark"
                            type="block">
                            <BRow>
                                <BCol class="mb-3" lg="12" v-if="$ac.hasAccess('store_full_access')">
                                    <label class="form-label" for="product-title-input">{{ $t('store.label.ref_no')
                                        }}</label>
                                    <input type="text" class="form-control" v-model="data.ref_no"
                                        id="product-title-input" :placeholder="$t('store.placeholder.ref_no')" />
                                </BCol>
                                <BCol class="mb-3" lg="12" v-if="$ac.hasAccess('store_full_access')">
                                    <label for="choices-publish-status-input" class="form-label">{{
                                        $t('store.label.user')
                                        }}</label>
                                    <dynamic-select v-model="data.user_id" :loadOptions="fetchUsers"
                                        :placeholder="$t('store.placeholder.user')" />
                                </BCol>
                                <BCol class="mb-3" lg="12">
                                    <label class="form-label" for="product-title-input">{{ $t('store.label.name')
                                        }}</label>
                                    <input type="text" class="form-control" v-model="data.name" id="product-title-input"
                                        :placeholder="$t('store.placeholder.name')" />
                                </BCol>
                                <BCol lg="12">
                                    <div class="hstack gap-2 justify-content-between">
                                        <BButton type="button" variant="danger" class="w-sm" @click="destroy(data.id)"
                                            v-if="$ac.hasAccess('store_full_access') || ($ac.hasAccess('store_delete') && $ac.hasAccessStore(data.id))"
                                            :disabled="$loading.get('store_detail_config_delete')">
                                            <loading :loading="$loading.get('store_detail_config_delete')">
                                                <i class="mdi mdi-delete-outline"></i>
                                                {{ $t('basic.btn.delete') }} {{ $t('menu.sub_header.store') }}
                                            </loading>
                                        </BButton>
                                        <BButton type="submit" variant="success" class="w-sm"
                                            v-if="$ac.hasAccess('store_full_access') || ($ac.hasAccess('store_create') && $ac.hasAccessStore(data.id))"
                                            :disabled="$loading.get('store_detail_config_submit')">
                                            <loading :loading="$loading.get('store_detail_config_submit')">
                                                <i class="mdi mdi-floppy me-1"></i>
                                                {{ $t('basic.btn.save') }}
                                            </loading>
                                        </BButton>
                                    </div>
                                </BCol>
                            </BRow>
                        </loading>
                    </BCardBody>
                </BCard>
            </b-form>
        </BCol>
    </BRow>
</template>